<template>
    <div class="erb-wrap">
        <div v-if="total > 0" class="erb-counts">
            <span
                v-for="r in topReactions"
                :key="r.type"
                class="erb-pill"
                :title="$t(`events.reactions.${r.type}`)"
            >
                <span class="erb-pill-emoji">{{ r.emoji }}</span>
                <span class="erb-pill-count">{{ summary[r.type] }}</span>
            </span>
            <span class="erb-total">{{ $t('events.reactions.total', { count: total }) }}</span>
        </div>
        <p v-else class="erb-empty">{{ $t('events.reactions.none') }}</p>
    </div>
</template>

<script>
const REACTIONS = [
    { type: 'like',  emoji: '👍' },
    { type: 'love',  emoji: '❤️' },
    { type: 'haha',  emoji: '😂' },
    { type: 'wow',   emoji: '😮' },
    { type: 'sad',   emoji: '😢' },
    { type: 'angry', emoji: '😡' }
]

export default {
    name: 'EventReactionsBar',
    props: {
        initialSummary: { type: Object, default: () => ({}) },
        initialTotal:   { type: Number, default: 0 }
    },
    computed: {
        summary() {
            return this.initialSummary
        },
        total() {
            return this.initialTotal
        },
        topReactions() {
            return REACTIONS
                .filter((r) => (this.summary[r.type] || 0) > 0)
                .sort((a, b) => (this.summary[b.type] || 0) - (this.summary[a.type] || 0))
        }
    }
}
</script>

<style scoped>
.erb-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.erb-counts {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.erb-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 999px;
    background: var(--v2-surface-1);
    border: 1px solid var(--v2-border);
    cursor: default;
}

.erb-pill-emoji {
    font-size: 1.1rem;
    line-height: 1;
}

.erb-pill-count {
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--v2-text-2);
}

.erb-total {
    font-size: 0.85rem;
    color: var(--v2-text-4);
}

.erb-empty {
    font-size: 0.875rem;
    color: var(--v2-text-4);
    margin: 0;
}
</style>
